export default "__VITE_ASSET__Bdfr2qFE__"